import React from 'react';
import { TextField, Button, CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const LezioneForm = ({
    progrLezione,
    onProgrLezioneChange,
    onAddLezione,
    disabled,
    submitting
}) => {
    return (
        <>
            <TextField
                fullWidth
                type="number"
                label="Progressivo Lezione (progr_lezione)"
                value={progrLezione}
                onChange={(e) => onProgrLezioneChange(e.target.value)}
                sx={{ mb: 3 }}
                disabled={disabled}
            />

            <Button
                variant="contained"
                className="btn-3d btn-3d-primary"
                fullWidth
                size="large"
                onClick={onAddLezione}
                disabled={disabled || !progrLezione || submitting}
                startIcon={<AddIcon />}
            >
                {submitting ? <CircularProgress size={24} color="inherit" /> : '+ Aggiungi lezione'}
            </Button>
        </>
    );
};

export default LezioneForm;
